import { defaultLightTheme, type RaThemeOptions } from 'react-admin'

/**
 * Palette A (harbour teal), shared with bombeo-app: teal for the app bar,
 * links and main actions; crane amber for accent actions (dark text on it);
 * green for completed events. Development builds use the same theme in grey,
 * as bombeo-app's development build does.
 */
const PALETTE_A = {
  primary: { main: '#0F5E66', dark: '#0A444A', light: '#2E8C96', contrastText: '#FFFFFF' },
  secondary: { main: '#E89B2E', dark: '#B06E14', light: '#F1B85C', contrastText: '#1A1A1A' },
  background: '#F4F7F7',
}

const GREY = {
  primary: { main: '#424242', dark: '#2B2B2B', light: '#6D6D6D', contrastText: '#FFFFFF' },
  secondary: { main: '#9E9E9E', dark: '#757575', light: '#BDBDBD', contrastText: '#1A1A1A' },
  background: '#F5F5F5',
}

/** Done-green for MARPOL/BOMBEO events, identical in both apps. */
export const EVENT_DONE_COLOR = '#1F9D6B'

export const bombeoTheme = (mode: string): RaThemeOptions => {
  const colors = mode === 'development' ? GREY : PALETTE_A
  return {
    ...defaultLightTheme,
    palette: {
      ...defaultLightTheme.palette,
      primary: colors.primary,
      secondary: colors.secondary,
      success: { main: EVENT_DONE_COLOR, contrastText: '#FFFFFF' },
      background: { default: colors.background },
    },
  }
}
